<template>
  <b-container class="d-flex flex-column mh-100" fluid>
    <div
      class="pagetitle-container d-flex justify-content-start align-items-center"
    >
      <div class="page-title">
        <h2>
          Cenníky
          <small>({{ count }})</small>
        </h2>
      </div>
      <div class="d-flex flex-grow-1">
        <input-filter
          ref="filter"
          :filters="table.filter"
          :options="filterOptions"
          @onReset="resetFilter"
          @onSearch="search"
        >
          <template #filter>
            <b-row>
              <b-col md="4">
                <b-form-group
                  label="Platné od:"
                  label-align-md="right"
                  label-cols-md="4"
                  label-for="date"
                >
                  <b-input-group class="input-group-labeled">
                    <date-picker
                      v-model="table.filter.date"
                      class="flex-grow-1 daterange-sm"
                      opens="right"
                      @update="search"
                    />
                    <b-input-group-append>
                      <b-btn
                        size="sm"
                        variant="link"
                        @click="
                          table.filter.date = { ge: null, lt: null }
                          search()
                        "
                      >
                        <b-icon icon="x" scale="1.5x" />
                      </b-btn>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
          </template>
        </input-filter>
      </div>
      <template v-if="$root.user.isAdmin">
        <div class="ml-3">
          <b-dropdown
            menu-class="dropdown-menu-animated"
            right
            size="lg"
            variant="secondary"
          >
            <template #button-content>
              <b-icon icon="gear" />
            </template>
            <b-dropdown-item-button @click="exportList">
              <b-icon class="mr-1" icon="file-earmark-spreadsheet" />
              Exportovať
            </b-dropdown-item-button>
          </b-dropdown>
          <b-btn
            class="text-uppercase"
            size="lg"
            variant="primary"
            @click="openAddPriceModal"
          >
            <b-icon class="mr-1" icon="plus" scale="1.5x" />
            Nová hodnota
          </b-btn>
        </div>
      </template>
    </div>
    <add-price ref="pricelistForm" />
    <div ref="scroll" v-bar class="bar-out">
      <div>
        <server-table
          ref="table"
          :api-request="apiRequest"
          :columns="table.columns"
          :searchable="false"
          :sort-by.sync="table.sortBy"
          :sort-desc="true"
          bordered
          hover
          striped
          @refreshed="onLoaded"
        >
          <template #cell(actions)="data">
            <b-dropdown class="btn-p-0" no-caret variant="link">
              <template slot="button-content">
                <b-icon icon="text-indent-left" scale="1.25x" />
              </template>
              <b-dropdown-item @click="edit(data.item.id, data.item.title)">
                <b-icon class="mr-1" icon="pencil-square" />
                Upraviť
              </b-dropdown-item>
              <b-dropdown-item
                @click="add(data.item.price_id, data.item.title)"
              >
                <b-icon class="mr-1" icon="plus" scale="1.5x" />
                Pridať
              </b-dropdown-item>
              <b-dropdown-item
                class="text-danger"
                @click.prevent="remove(data.item.id)"
              >
                <b-icon class="mr-1" icon="trash" />
                Vymazať
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </server-table>
      </div>
    </div>
  </b-container>
</template>
<script>
import InputFilter from '@/components/InputFilter'
import DatePicker from '@/components/inputs/DatePicker'
import ServerTable from '@/components/ServerTable'
import AddPrice from './Add'

export default {
  components: {
    InputFilter,
    DatePicker,
    ServerTable,
    AddPrice,
  },
  data() {
    return {
      loading: false,
      table: {
        columns: [
          {
            key: 'actions',
            label: '',
            class: 'th-shrink',
          },
          {
            key: 'title',
            label: 'Položka',
            formatter: (value) => value || '-',
            sortable: true,
            sortableKey: 'title',
            searchable: true,
          },
          {
            key: 'unit',
            label: 'Jednotka',
            formatter: (value) => value || '-',
          },
          {
            key: 'value',
            label: 'Hodnota',
            class: 'text-right',
            formatter: (value) =>
              this.$options.filters.formatNumber(value, 4) || '-',
            sortable: true,
            sortableKey: 'value',
            searchable: true,
          },
          {
            key: 'validFrom',
            label: 'Platné od',
            formatter: (value) =>
              this.$options.filters.formatDate(value) || '-',
            sortable: true,
            sortableKey: 'validFrom',
            searchable: true,
          },
        ],
        sortBy: 'validFrom',
        filter: {
          date: { ge: null, lt: null },
        },
      },
      filterOptions: {
        placeholder: 'Filtrovanie a hľadanie...',
      },
      count: null,
    }
  },
  mounted() {
    this.$root.$on('reloadPriceList', this.$refs.table.refresh)
  },
  beforeDestroy() {
    this.$root.$off('reloadPriceList')
  },
  methods: {
    apiRequest(params) {
      return this.$api.get('pricelist/get_list', {
        params: { filter: this.table.filter, ...params },
      })
    },
    onLoaded() {
      this.count = this.$refs.table.totalRows
    },
    search() {
      this.$refs.table.searchVal = this.$refs.filter.value
      this.$nextTick(() => {
        this.$refs.table.search()
      })
    },
    resetFilter() {
      this.$refs.table.reset()
    },
    openAddPriceModal() {
      this.$root.$emit('modal-show', 'add-price')
    },
    add(id, title) {
      this.$refs.pricelistForm.title = title
      this.$refs.pricelistForm.form.price_id = id
      this.$nextTick(() => {
        this.openAddPriceModal()
      })
    },
    edit(id, title) {
      this.$refs.pricelistForm.edit = true
      this.$refs.pricelistForm.title = title
      this.$refs.pricelistForm.form.id = id
      this.$nextTick(() => {
        this.openAddPriceModal()
      })
    },
    remove(id) {
      this.$swal({
        title: 'Ste si istý?',
        text: 'Naozaj chcete odstrániť túto hodnotu?',
        type: 'info',
        position: 'top',
        showConfirmButton: true,
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.$api
            .post('pricelist/delete', {
              id: id,
            })
            .then(() => {
              this.$refs.table.refresh()
            })
        }
      })
    },
    exportList() {
      this.$swal({
        toast: true,
        type: 'info',
        position: 'top-end',
        title: 'Pripravujem export...',
      })
      this.$api
        .get('pricelist/export', {
          params: {
            query: this.$refs.filter.value,
            filter: this.table.filter,
            ...this.$refs.table.getRequestParams(),
            startAt: 0,
            maxResults: -1,
          },
          responseType: 'blob',
        })
        .then((res) => {
          saveAs(new Blob([res.data]), 'cenniky.xlsx')
          this.$swal({
            toast: true,
            type: 'success',
            position: 'top-end',
            title: 'Export pripravený',
            timer: 5000,
          })
        })
        .catch(() => {
          this.$swal({
            toast: true,
            type: 'error',
            position: 'top-end',
            title: 'Chyba pri exportovaní',
            timer: 5000,
          })
        })
    },
  },
}
</script>
